import styled from "styled-components";

export const StatusBadge = styled.div<{ color: string }>`
  margin-top: -2.5em;
  text-align: center;
  background-color: ${props => props.color};
  border-radius: 3px;
  margin-bottom: 1em;
  color: var(--dark);

  @media (max-width: 768px) {
    margin-top: 1em;
    width: 95px;
    margin-right: -10em;
  }
`;
